import React from "react"
import globalMU from "globalMU"

type Props = {
    children: React.ReactNode
    /**
     * Recuperação silenciosa: em vez de trocar a árvore pela mensagem de erro, o limite volta a
     * renderizar `children` no tick seguinte. Usar quando o erro capturado é sabidamente inócuo e
     * acontece no DESMONTE de uma subárvore que já ia sumir da tela de qualquer forma — caso do
     * `react-modern-calendar-datepicker`, que na limpeza do próprio `useEffect` lê
     * `ref.current.removeEventListener` com `ref.current` já nulo (PA 493860). Sem isto, um erro
     * de desmonte de um menu derruba a tela inteira, porque o React propaga o erro para o limite
     * mais próximo que NÃO está sendo removido.
     */
    recuperarAutomaticamente?: boolean
}

type State = {
    temErro: boolean
}

/**
 * Sem isto, um erro não tratado durante commit/efeitos de QUALQUER componente da árvore
 * (ex.: bug de limpeza de efeito em lib de terceiros, PA 493860 —
 * `react-modern-calendar-datepicker` lendo `ref.current.removeEventListener` já nulo no
 * unmount) derruba a raiz React inteira: o container fica vazio e a tela toda some, mesmo
 * a ação que disparou o erro já tendo sido concluída com sucesso no servidor.
 */
export class LimiteDeErroReact extends React.Component<Props, State> {
    override state: State = { temErro: false }

    static getDerivedStateFromError(): State {
        return { temErro: true }
    }

    override componentDidCatch(erro: unknown, info: React.ErrorInfo) {
        if (this.props.recuperarAutomaticamente) {
            console.warn("LimiteDeErroReact: erro ignorado no desmonte da subárvore:", erro)
            // Fora do commit atual: reagendar o render dos filhos só depois que o React terminar
            // de processar a remoção que gerou o erro.
            setTimeout(() => this.setState({ temErro: false }), 0)
            return
        }
        console.error("LimiteDeErroReact capturou um erro não tratado:", erro, info.componentStack)
        globalMU.unblockUI()
        globalMU.showErrorMessage("O sistema está temporariamente indisponível. Aguarde alguns minutos e tente novamente. Se o problema persistir entre em contato com nossa Central de Suporte.")
    }

    override render() {
        if (this.state.temErro) {
            if (this.props.recuperarAutomaticamente) return null

            // return (
            //     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px", gap: "12px" }}>
            //         <p>Ocorreu um erro inesperado nesta tela.</p>
            //         <button
            //             id="limite-de-erro-react__botao-recarregar"
            //             className="no-global-button"
            //             onClick={() => window.location.reload()}
            //         >
            //             Recarregar página
            //         </button>
            //     </div>
            // )
        }

        return this.props.children
    }
}
